<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->

    <UserLink :user="activity.causer" v-if="activity.causer"/>

    <span v-if="!activity.causer">{{ $t('system.system') }}</span>

    <!--ACTIVITY LOG ACTION-->
    <span v-if="activity.description === 'added'">
      {{ $t('actions.ran') }}
    </span>
    <span v-else>
      {{ $t('actions.' + $options.filters.slugify(activity.description)) }}
    </span>

    <!--CREATED-->
    <div v-if="activity.description === 'added'">
      <div v-if="activity.subject">
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'projects.view', params: { slug: activity.subject.slug }}">
          {{activity.properties.title}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'projects.view', params: { slug: activity.properties.slug }}">
          {{activity.properties.title}}
        </router-link>
      </div>
    </div>

    <!--CREATED-->
    <div v-if="activity.description === 'created'">
      <div v-if="activity.subject">
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'projects.view', params: { slug: activity.subject.slug }}">
          {{activity.properties.title}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'projects.view', params: { slug: activity.properties.slug }}">
          {{activity.properties.title}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'deleted'">
      <div v-if="activity.subject">
        <span> {{ $t('project.log.title') | lowerCase}}</span>

          {{activity.properties.title}}

      </div>

      <div v-else>
        <span> {{ $t('project.log.title') | lowerCase}}</span>

          {{activity.properties.title}}

      </div>
    </div>

    <!--UPDATED-->
    <div v-if="activity.description === 'updated'">
      <div v-if="activity.subject">
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'projects.view', params: { slug: activity.subject.slug }}">
          {{activity.properties.attributes.title}}
        </router-link>
      </div>

      <div v-else>
        <span> {{ $t('project.log.title') | lowerCase}}</span>
        <router-link :to="{ name: 'activities.view', params: { slug: activity.properties.attributes.slug }}">
          {{activity.properties.attributes.title}}
        </router-link>
      </div>

      <div v-if="changes">
        <div class="mt-2 small">
          <span class="text-warning text-bold">
            {{ $t('activities.log.changes')}}
          </span>
        </div>
        <div v-for="(item, index) in activity.properties.attributes">
          <div v-if="item !== activity.properties.old[index]">
            <span class="small" v-if="!isObject(item)">
              <span class="text-bold">{{makeTitle(index)}}</span>

              <span v-if="index === 'updated_at' || index === 'start_date' || index === 'end_date'" class="text-bold">
                <span> {{ $t('activities.log.changed_to')}} </span>
                {{item | formatDate}}
              </span>
              <span v-else-if="index === 'rules_followed'" class="text-bold">
                <span> {{ $t('activities.log.changed_to')}} </span>
                <span v-if="item == 1">{{ $t('system.on')}}</span>
                <span v-else>{{ $t('system.off')}}</span>
              </span>
              <span v-else-if="index === 'scope_data'" class="text-bold">
                <span> {{ $t('activities.log.changed')}} </span>
              </span>
              <span v-else-if="index === 'scheduled'" class="text-bold">
                <span> {{ $t('activities.log.changed_to')}} </span>
                <span v-if="item == 1">{{ $t('system.on')}}</span>
                 <span v-else>{{ $t('system.off')}}</span>
              </span>
              <span v-else class="text-bold">
                <span> {{ $t('activities.log.changed_to')}} </span>
                {{item}}
              </span>
            </span>
            <div class="small mt-2" v-if="index === 'data_objects'">
              <div v-for="data in removedData(activity.properties)" class="mb-1">
                <span>
                  <span class="badge badge-info p-1">
                    {{data.name}}
                  </span>
                  {{ $t('activities.log.data_object_removed')}}
                </span>
              </div>
              <div v-for="data in addedData(activity.properties)" class="mb-1">
                <span>
                  <span class="badge badge-info p-1">
                    {{data.name}}
                  </span>
                  {{ $t('activities.log.data_object_added')}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'ActivityProject',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
